import api from '../instance';

export const locationsService = {
  getCountries: async () => {
    try {
      const res = await api.projectApi.get('/location/countries', {
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching countries');
    }
  },
};
